export const isFetchedData = (obj) => obj instanceof Object && 'loadingState' in obj;
